import * as React from "react";
import {
  WithStyles,
  withStyles,
  StyleRulesCallback
} from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

interface IProps {
  isGreen?: boolean;
}

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
  body: {
    fontSize: 16,
    fontWeight: 300,
    color: palette.common.white,
    marginTop: spacing.unit,
    marginBottom: spacing.unit
  },
  green: {
    color: palette.primary.main
  }
});

@(withStyles(styles) as any)
export default class JobsSectionBody extends React.Component<
  IProps & Partial<WithStyles<any>>
> {
  public render() {
    return (
      <Typography className={this.className()} component="span">
        {this.props.children}
      </Typography>
    );
  }

  private className() {
    const { classes, isGreen } = this.props;
    const classNames = [classes!.body];
    if (isGreen) {
      classNames.push(classes!.green);
    }

    return classNames.join(" ");
  }
}



// WEBPACK FOOTER //
// ./src/components/JobsSectionBody.tsx